import styled, { css } from 'styled-components';
import { lineHeight, theme, toRem } from 'design';

interface HeaderCellProps {
  align?: 'center' | 'left' | 'right';
  value?: string;
  type?: 'actions' | 'default';
}

const HeaderCell = styled.th<HeaderCellProps>`
  position: relative;
  padding: 0 ${toRem(theme.space.xl)};
  font-family: ${theme.font.family.euclid};
  font-weight: ${theme.font.weight.semiBold};
  font-size: ${toRem(theme.font.size.xxs)};
  line-height: ${lineHeight(theme.font.size.xxs)};
  text-align: left;
  white-space: nowrap;
  color: ${theme.color.neutral[900]};
  border-bottom: ${toRem(1)} solid ${theme.color.neutral[200]};

  ${({ align }) =>
    align === 'center' &&
    css`
      text-align: center;

      > * {
        margin: 0 auto;
      }
    `}

  ${({ align }) =>
    align === 'right' &&
    css`
      justify-content: flex-end;
      text-align: right;

      > * {
        margin: 0 0 0 auto;
      }
    `}

  ${({ type }) =>
    type === 'actions' &&
    css`
      width: ${toRem(33)};
    `}
`;

export default HeaderCell;
